module.exports = __webpack_public_path__ + "media/careers_screens@lg-4e6fd6cdbbca341dca6ec9bec9eadc92.png";